import * as React from 'react';
import classnames from 'classnames';

import CrossButton from 'components/buttons/cross-button/CrossButton';
import MediaPreview from 'components/MediaPreview';

import type { CampaignAsset } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  asset: CampaignAsset,
  canEdit: boolean,
  width?: number,
  height?: number,
  className?: string,
  onDeleteAsset?: (a: CampaignAsset) => void
};

class CampaignAssetsGalleryItem extends React.PureComponent<Props> {
  handleDelete = (event: SyntheticEvent<HTMLElement>): void => {
    event.preventDefault();
    event.stopPropagation();

    const { asset, onDeleteAsset } = this.props;

    if (onDeleteAsset) {
      onDeleteAsset(asset);
    }
  };

  render() {
    const { asset, canEdit, className, onDeleteAsset, width = 80, height = 80 } = this.props;

    const mediaPreviewItem = {
      id: asset.id,
      url: asset.url,
      format: asset.assetType,
      fileName: asset.fileName
    };

    const itemClassName = classnames('assets-grid-gallery__item', className);

    return (
      <li className={itemClassName}>
        <MediaPreview
          attachment={mediaPreviewItem}
          width={width}
          height={height}
        />
        {
          canEdit && onDeleteAsset &&
            <div className="assets-grid-gallery__cross">
              <CrossButton
                type="corner-closer"
                onClick={this.handleDelete}
              />
            </div>
        }
      </li>
    );
  }
}

export default CampaignAssetsGalleryItem;
